const getFabric = () => import('fabric/dist/fabric')

angular
  .module('deskfy.core')
  .controller('InputSignatureController', InputSignatureController)

/* @ngInject */
function InputSignatureController ($scope, $timeout, Utils, CONSTANTS) {
  $scope.flags = {
    saved: false
  }

  let canvas

  const api = {
    _createCanvas
  }
  this.getApi = () => api

  activate()

  function activate () {
    $timeout(api._createCanvas, 100, false)

    if ($scope.value) {
      $scope.signatureSrc = Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_DOWNLOAD_ID, [$scope.value])
    }
  }

  $scope.clearCanvas = function () {
    canvas.clear()
    $scope.model = ''
    $scope.flags.saved = false
  }

  $scope.saveCanvas = function () {
    if (canvas._objects.length) {
      $scope.model = canvas.toSVG()
      $scope.flags.saved = true
    }
  }

  function _createCanvas () {
    getFabric().then(({ fabric }) => {
      canvas = new fabric.Canvas(`signature-canvas-${$scope.count}`)
      canvas.isDrawingMode = true
      canvas.on('mouse:up', () => {
        $scope.flags.saved = false
        $scope.$apply()
      })
    })
  }
}
